// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/aniversario10/trofeo.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appbar-aniversario-10 > .app-bar-generic {
  height: 6vh;
  padding-top: 0;
}

.appbar-aniversario-10 > .app-bar-generic > .parrafo-new-appbar {
  margin-top: 0;
}

.appbar-aniversario-10
  > .app-bar-generic
  > .parrafo-new-appbar
  > .icono-color-new-appbar {
  color: #fff;
}

.anv-header-logo {
  padding-top: 7vh;
  padding-bottom: 4vh;
  position: fixed;
  width: 100vw;
}

.anv-logo {
  margin: 0 auto;
  margin-top: 2rem;
  width: 90vw;
}

.anv-content {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  overflow-y: scroll;
  position: relative;
  top: 2vh;
  width: 100vw;
}

.anv-header,
.anv-header-trofeo {
  background-color: #2b363b;
  padding-top: 5vh;
  padding-bottom: 1vh;
  color: #fff;
}

.anv-header-trofeo {
  background: #2b363b url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-position: right 4vh;
}

.anv-background {
  background-color: #e3e3e3;
  background-size: contain;
  height: 100vh;
  overflow: scroll;
  position: fixed;
  z-index: -1;
}

.anv-title-trofeo {
  width: 80%;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  text-align: left;
  padding: 1em;
}

.anv-title-trofeo .anv-title-text {
  font-size: 2em;
}

.anv-title-trofeo .anv-trofeo-text,
.anv-title-trofeo .anv-footer-text {
  font-size: 1.2em;
  line-height: 1.2em;
  margin: 0.5em auto;
}

.anv-title-text {
  font-style: normal;
  font-size: 2em;
  line-height: 1.3em;
}

.anv-litros {
  font-style: normal;
  font-size: 7em;
  line-height: 1em;
}

.anv-litros-decimals {
  font-style: normal;
  font-size: 0.5em;
  line-height: 42px;
}

.anv-footer-text {
  font-style: normal;
  font-size: 1.8em;
  line-height: 1.3em;
}

.anv-detalles-btn {
  color: #da0d29;
  border: #ffffff 1px solid;
  background-color: #ffffff;
  font-size: 4.7vw;
  text-align: center;
  width: 88%;
  margin: 2vh auto;
  padding: 1.5vh;
  font-weight: 800;
  border-radius: 4px;
}

.anv-promo-info {
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 2vh;
  padding-top: 2vh;
  padding-bottom: 2vh;
  background-color: #fff;
  height: auto;
  margin-bottom: 2vh;
  padding-bottom: 3vh;
  padding-right: 2vw;
  width: 88vw;
}

.anv-info-header {
  display: block;
  text-align: left;
  margin: 1vh 5vw 3vh 5vw;
}

.anv-info-header.center {
  text-align: center;
}

.anv-info-title {
  font-size: 1.2em;
  text-align: left;
}

.anv-step-item {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  font-size: 0.83em;
  line-height: 1.3em;
}

.anv-step {
  margin: 1vh;
}

.anv-icon {
  float: left;
  margin: 0 3.5vw 0 5vw;
  background-color: #da0d29;
  color: #fff;
  border-radius: 50%;
  padding: 0.4em 0.5em;
  display: flex;
  vertical-align: middle;
  max-width: 2.2em;
}

.anv-icon img {
  height: 1.8em;
  margin: 0.2em;
}

.anv-info-footer {
  margin-top: 2vh;
  padding: 1vh 5vw;
  font-size: 1.2em;
}

.anv-social-media {
  display: flex;
  justify-content: space-evenly;
}

.anv-btn-social {
  color: #fff;
  border: #2b363b 1px solid;
  background-color: #2b363b;
  font-size: 1.1em;
  padding: 0.5em 0.2em;
  width: 38vw;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.anv-logo-social {
  margin-right: 0.8em;
  margin-left: 0.2em;
}

.mymodalaniversario10 {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  z-index: 4;
  left: 10vw;
  width: 90vw;
  background-color: #fff;
  overflow: auto;
  border-radius: 10px;
  margin: 20% auto;
  overflow-x: hidden;
}

.mymodalinforepostaje {
  font-family: "RedHatDisplay-Regular", sans-serif !important;
  z-index: 4;
  left: 10vw;
  width: 90vw;
  background-color: #fff;
  overflow: auto;
  border-radius: 10px;
  margin: 50% auto;
  overflow-x: hidden;
}

.mymodalaniversario10:focus-visible,
.mymodalaniversario10:focus {
  outline-width: 0;
  outline: none;
}

.anv-content-dialog {
  margin-left: 5vw;
  margin-right: 5vw;
  margin-top: 3vh;
  color: #2b363b;
}

.anv-dialog-title {
  display: block;
  font-size: 1.7em;
  margin-top: 4vh;
  text-align: center;
}

.anv-dialog-logo img {
  margin: 2vh auto 0 auto;
}

.anv-dialog-footer {
  display: block;
  font-size: 4em;
  text-align: center;
}

.anv-dialog-info {
  font-size: 1em;
  line-height: 1.2em;
  max-width: 90%;
  margin-top: 1vh;
  margin-bottom: 2vh;
}

.anv-dialog-info.link {
  color: #028dcc;
}

.anv-info-footer.small {
  color: rgb(24, 24, 24);
  font-size: 0.8em;
  line-height: 1.5em;
}

.anv-info-footer.small p {
  margin-bottom: 0.8em;
  color: rgb(24, 24, 24);
}

.anv-dialog-info.small {
  color: #949a9c;
  font-size: 0.8em;
}

.anv-dialog-info-litros {
  background-color: #2b363b;
  color: #fff;
  display: flex;
  align-items: center;
  margin-top: 3vh;
}

.anv-dialog-litros-cantidad,
.anv-dialog-litros-info {
  padding-top: 2vh;
  padding-left: 2vh;
  padding-bottom: 2vh;
  padding-right: 1vh;
}

.anv-dialog-litros-cantidad {
  font-size: 2.5em;
}

.anv-dialog-info-litros-decimals {
  font-size: 0.4em;
}

.anv-dialog-info-sorteo {
  margin-top: 3vh;
}

.anv-dialog-info-sorteo .anv-icon {
  margin-left: 0;
}

.anv-dialog-info-sorteo li.anv-step {
  font-size: 1.3em;
  margin: 1vh 0;
}

.anv-modal-repostaje-bases {
  padding-bottom: 0;
}

.anv-dialog-button {
  color: #fff;
  border: #db0b27 1px solid;
  background-color: #db0b27;
  font-size: 4.7vw;
  text-align: center;
  width: 85%;
  margin: 0 auto 5vh;
  padding: 1.5vh;
  font-weight: 800;
  border-radius: 4px;
}

@media screen and (min-width: 768px) {
  .anv-clock-number {
    font-size: 11vh;
    line-height: 10vh;
  }

  .anv-clock-text {
    font-size: 2.2vh;
  }

  .anv-icon {
    background-color: #da0d29;
    color: #fff;
    border-radius: 50%;
    font-size: 0.8em;
    padding: 0.2em 0.8em;
    float: left;
    margin: 3vh 5vw 0 5vw;
    line-height: 1.8em;
  }

  .anv-icon img {
    width: 6vw;
  }

  .anv-discount-prox,
  .anv-dates-info {
    height: 9vh;
    padding-top: 1vh;
  }

  .mymodalaniversario10 {
    margin: 15% auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Aniversario10/aniversario10.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qEAA8E;EAC9E,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,UAAU;EACV,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".appbar-aniversario-10 > .app-bar-generic {\n  height: 6vh;\n  padding-top: 0;\n}\n\n.appbar-aniversario-10 > .app-bar-generic > .parrafo-new-appbar {\n  margin-top: 0;\n}\n\n.appbar-aniversario-10\n  > .app-bar-generic\n  > .parrafo-new-appbar\n  > .icono-color-new-appbar {\n  color: #fff;\n}\n\n.anv-header-logo {\n  padding-top: 7vh;\n  padding-bottom: 4vh;\n  position: fixed;\n  width: 100vw;\n}\n\n.anv-logo {\n  margin: 0 auto;\n  margin-top: 2rem;\n  width: 90vw;\n}\n\n.anv-content {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  overflow-y: scroll;\n  position: relative;\n  top: 2vh;\n  width: 100vw;\n}\n\n.anv-header,\n.anv-header-trofeo {\n  background-color: #2b363b;\n  padding-top: 5vh;\n  padding-bottom: 1vh;\n  color: #fff;\n}\n\n.anv-header-trofeo {\n  background: #2b363b url(\"../assets/images/aniversario10/trofeo.svg\") no-repeat;\n  background-position: right 4vh;\n}\n\n.anv-background {\n  background-color: #e3e3e3;\n  background-size: contain;\n  height: 100vh;\n  overflow: scroll;\n  position: fixed;\n  z-index: -1;\n}\n\n.anv-title-trofeo {\n  width: 80%;\n  margin: 0 auto;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  text-align: left;\n  padding: 1em;\n}\n\n.anv-title-trofeo .anv-title-text {\n  font-size: 2em;\n}\n\n.anv-title-trofeo .anv-trofeo-text,\n.anv-title-trofeo .anv-footer-text {\n  font-size: 1.2em;\n  line-height: 1.2em;\n  margin: 0.5em auto;\n}\n\n.anv-title-text {\n  font-style: normal;\n  font-size: 2em;\n  line-height: 1.3em;\n}\n\n.anv-litros {\n  font-style: normal;\n  font-size: 7em;\n  line-height: 1em;\n}\n\n.anv-litros-decimals {\n  font-style: normal;\n  font-size: 0.5em;\n  line-height: 42px;\n}\n\n.anv-footer-text {\n  font-style: normal;\n  font-size: 1.8em;\n  line-height: 1.3em;\n}\n\n.anv-detalles-btn {\n  color: #da0d29;\n  border: #ffffff 1px solid;\n  background-color: #ffffff;\n  font-size: 4.7vw;\n  text-align: center;\n  width: 88%;\n  margin: 2vh auto;\n  padding: 1.5vh;\n  font-weight: 800;\n  border-radius: 4px;\n}\n\n.anv-promo-info {\n  border-radius: 4px;\n  margin: 0 auto;\n  margin-top: 2vh;\n  padding-top: 2vh;\n  padding-bottom: 2vh;\n  background-color: #fff;\n  height: auto;\n  margin-bottom: 2vh;\n  padding-bottom: 3vh;\n  padding-right: 2vw;\n  width: 88vw;\n}\n\n.anv-info-header {\n  display: block;\n  text-align: left;\n  margin: 1vh 5vw 3vh 5vw;\n}\n\n.anv-info-header.center {\n  text-align: center;\n}\n\n.anv-info-title {\n  font-size: 1.2em;\n  text-align: left;\n}\n\n.anv-step-item {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n  font-size: 0.83em;\n  line-height: 1.3em;\n}\n\n.anv-step {\n  margin: 1vh;\n}\n\n.anv-icon {\n  float: left;\n  margin: 0 3.5vw 0 5vw;\n  background-color: #da0d29;\n  color: #fff;\n  border-radius: 50%;\n  padding: 0.4em 0.5em;\n  display: flex;\n  vertical-align: middle;\n  max-width: 2.2em;\n}\n\n.anv-icon img {\n  height: 1.8em;\n  margin: 0.2em;\n}\n\n.anv-info-footer {\n  margin-top: 2vh;\n  padding: 1vh 5vw;\n  font-size: 1.2em;\n}\n\n.anv-social-media {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.anv-btn-social {\n  color: #fff;\n  border: #2b363b 1px solid;\n  background-color: #2b363b;\n  font-size: 1.1em;\n  padding: 0.5em 0.2em;\n  width: 38vw;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.anv-logo-social {\n  margin-right: 0.8em;\n  margin-left: 0.2em;\n}\n\n.mymodalaniversario10 {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  z-index: 4;\n  left: 10vw;\n  width: 90vw;\n  background-color: #fff;\n  overflow: auto;\n  border-radius: 10px;\n  margin: 20% auto;\n  overflow-x: hidden;\n}\n\n.mymodalinforepostaje {\n  font-family: \"RedHatDisplay-Regular\", sans-serif !important;\n  z-index: 4;\n  left: 10vw;\n  width: 90vw;\n  background-color: #fff;\n  overflow: auto;\n  border-radius: 10px;\n  margin: 50% auto;\n  overflow-x: hidden;\n}\n\n.mymodalaniversario10:focus-visible,\n.mymodalaniversario10:focus {\n  outline-width: 0;\n  outline: none;\n}\n\n.anv-content-dialog {\n  margin-left: 5vw;\n  margin-right: 5vw;\n  margin-top: 3vh;\n  color: #2b363b;\n}\n\n.anv-dialog-title {\n  display: block;\n  font-size: 1.7em;\n  margin-top: 4vh;\n  text-align: center;\n}\n\n.anv-dialog-logo img {\n  margin: 2vh auto 0 auto;\n}\n\n.anv-dialog-footer {\n  display: block;\n  font-size: 4em;\n  text-align: center;\n}\n\n.anv-dialog-info {\n  font-size: 1em;\n  line-height: 1.2em;\n  max-width: 90%;\n  margin-top: 1vh;\n  margin-bottom: 2vh;\n}\n\n.anv-dialog-info.link {\n  color: #028dcc;\n}\n\n.anv-info-footer.small {\n  color: rgb(24, 24, 24);\n  font-size: 0.8em;\n  line-height: 1.5em;\n}\n\n.anv-info-footer.small p {\n  margin-bottom: 0.8em;\n  color: rgb(24, 24, 24);\n}\n\n.anv-dialog-info.small {\n  color: #949a9c;\n  font-size: 0.8em;\n}\n\n.anv-dialog-info-litros {\n  background-color: #2b363b;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  margin-top: 3vh;\n}\n\n.anv-dialog-litros-cantidad,\n.anv-dialog-litros-info {\n  padding-top: 2vh;\n  padding-left: 2vh;\n  padding-bottom: 2vh;\n  padding-right: 1vh;\n}\n\n.anv-dialog-litros-cantidad {\n  font-size: 2.5em;\n}\n\n.anv-dialog-info-litros-decimals {\n  font-size: 0.4em;\n}\n\n.anv-dialog-info-sorteo {\n  margin-top: 3vh;\n}\n\n.anv-dialog-info-sorteo .anv-icon {\n  margin-left: 0;\n}\n\n.anv-dialog-info-sorteo li.anv-step {\n  font-size: 1.3em;\n  margin: 1vh 0;\n}\n\n.anv-modal-repostaje-bases {\n  padding-bottom: 0;\n}\n\n.anv-dialog-button {\n  color: #fff;\n  border: #db0b27 1px solid;\n  background-color: #db0b27;\n  font-size: 4.7vw;\n  text-align: center;\n  width: 85%;\n  margin: 0 auto 5vh;\n  padding: 1.5vh;\n  font-weight: 800;\n  border-radius: 4px;\n}\n\n@media screen and (min-width: 768px) {\n  .anv-clock-number {\n    font-size: 11vh;\n    line-height: 10vh;\n  }\n\n  .anv-clock-text {\n    font-size: 2.2vh;\n  }\n\n  .anv-icon {\n    background-color: #da0d29;\n    color: #fff;\n    border-radius: 50%;\n    font-size: 0.8em;\n    padding: 0.2em 0.8em;\n    float: left;\n    margin: 3vh 5vw 0 5vw;\n    line-height: 1.8em;\n  }\n\n  .anv-icon img {\n    width: 6vw;\n  }\n\n  .anv-discount-prox,\n  .anv-dates-info {\n    height: 9vh;\n    padding-top: 1vh;\n  }\n\n  .mymodalaniversario10 {\n    margin: 15% auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
